var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Stack, Typography } from '@mui/material';
export var StepContentPanel = function (_a) {
    var title = _a.title, description = _a.description, action = _a.action, children = _a.children;
    return (_jsxs(Stack, __assign({ spacing: 4 }, { children: [title && (_jsx(Typography, __assign({ variant: "h3", gutterBottom: true }, { children: title }))), (description || action) && (_jsxs(Stack, __assign({ direction: "row", alignItems: "center", flexWrap: "wrap", useFlexGap: true, gap: 2, sx: { width: '100%', justifyContent: 'space-between', mt: title ? -1 : 0 } }, { children: [description && _jsx(Typography, __assign({ sx: { flex: '1 1 280px', minWidth: 0, pr: { sm: 3 } } }, { children: description })), action && (_jsx(Box, __assign({ sx: {
                            flex: '0 0 auto',
                            width: { xs: '100%', sm: 'auto' },
                            ml: 'auto',
                            display: 'flex',
                            justifyContent: 'flex-end',
                        } }, { children: action })))] }))), children] })));
};
